export default "__VITE_ASSET__DZ09AtGg__"